"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoiceCallTableEnum = void 0;
var VoiceCallTableEnum;
(function (VoiceCallTableEnum) {
    VoiceCallTableEnum["VoiceInternalCall"] = "Internal";
    VoiceCallTableEnum["VoiceCall"] = "ConversationInternal";
    VoiceCallTableEnum["VoiceChanSpy"] = "ChanSpy";
})(VoiceCallTableEnum = exports.VoiceCallTableEnum || (exports.VoiceCallTableEnum = {}));
